import getKey from 'lodash/get';
import setKey from 'lodash/set';

import React from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';

// import List from 'antd/lib/list';
// import Avatar from 'antd/lib/avatar';
// import Button from 'antd/lib/button';

import AntdTable from 'antd/lib/table';

import {
  ShopOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';

import Admin from 'hive-admin';
import ObjectId from 'bson-objectid';

import Types from '../../../modules/types';

import {
  productTypeNotMerchant,
} from './helpers';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
import createSlug from '../../../helpers/createSlug';
import createSku from '../../../helpers/createSku';

import { IconDelete } from '../../../components/ActionDelete';

import {
  getCalculatedPriceWithoutVat,
  getCalculatedPriceIncludingVat,
} from './variation';

const TableInputHTML = ({ className, disabled, ...props }) => (
  <input
    className={`ant-input${disabled ? ' ant-input-disabled' : ''
      } ${className || ''
      }`}
    disabled={disabled}
    {...props}
  />
);

export default [Admin.compileFromLibrary(getFilterWithCol(['Action', {
  name: 'clear-skus',
  title: 'Clear SKUs',
  ghost: true,
  style: { width: '100%' },
  skip: [
    productTypeNotMerchant,
    ['condition.fieldIsNotTrue', 'showVariations'],
  ],
  popconfirm: {
    title: 'Clearing SKUs will also clear current stock',
    okButtonProps: { type: 'danger', icon: 'delete' },
    okText: 'Clear',
    cancelButtonProps: {},
    icon: <IconDelete />,
  },
  onClick: (props) => {
    // console.log(props, ...args);
    props.form.setFieldsValue({ variations: [] });
  },
}], 12)),
  Admin.compileFromLibrary(getFilterWithCol(['ActionWithFormModal', {
    name: 'generate-skus',
    title: 'Generate SKUs',
    ghost: true,
    style: { width: '100%' },
    skip: [
      props => {
        const form = (props.parentForm || props.form);
        return !!(
          form.getFieldValue('type') !== 'MERCHANT_PRODUCT'
          || form.getFieldValue('showVariations') !== true
        );
      },
    ],
    modalProps: {
      centered: true,
      closable: true,
      width: '90%',
      destroyOnClose: true,
      className: 'generate-skus-modal',
    },
    // disabled: [
    //   // viewerIsNotAdmin,
    //   props => {
    //     const variants = props.form.getFieldValue('variants');
    //     if (!variants?.[0]?.choices?.[0]?.label?.length) {
    //       return true;
    //     }
    //     const variations = props.form.getFieldValue('variations');
    //     if (!variations || !variations?.length || variations?.[0]?.isDefault) {
    //       return false;
    //     }
    //     return true;
    //   },
    // ],
    shouldOpenModal: async (props) => {
      try {
        const values = await props.parentForm.validateFieldsAndScroll();
        if (!values?.variants?.[0]?.choices?.[0]?.label?.length) {
          throw Object.assign(new Error('Invalid field'), {
            errors: {
              variants: {
                errors: [{
                  message: 'Need at least one valid variant',
                }],
              },
            },
          });
        }
        return true;
      } catch (error) {
        const message = (
          error
            ?.errors
            ?.[Object.keys(error?.errors || {})?.[0]]
            ?.errors
            ?.[0]
            ?.message
        );
        if (message) {
          Admin.showMessage(
            message,
            'error',
            4,
          );
        }
        return false;
      }
    },
    overridableKeys: [
      'height',
      'width',
      'length',
      'weight',
      'price',
      'priceIncludingVat',
      'priceBeforeSale',
      'priceBeforeSaleIncludingVat',
    ],
    actions: [
      ['Action', {
        name: 'generate',
        onClick: (props) => {
          const { variations } = props.form.getFieldValue('skus');
          const result = variations.reduce(
            (agr, variation) => {
              if (!variation._isMissing) {
                variation = { ...variation };
                variation.overrides = [];
                props.overridableKeys.forEach((key) => {
                  const valueRaw = variation[key];
                  const value = parseFloat(valueRaw, 10);
                  if (
                    Number.isFinite(value)
                    && `${variation.defaultValues[key]}` !== `${value}`
                  ) {
                    variation[key] = parseFloat(value || 0);
                    variation.overrides.push(key);
                  } else {
                    variation[key] = parseFloat(
                      variation.defaultValues[key] || 0
                    );
                  }
                });
                agr.push(variation);
              }
              return agr;
            },
            [],
          );
          try {
            props.parentForm.setFields({
              variations: {
                value: result,
                touched: true,
              },
            });
            props.modalAction.handleCancel();
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          }
        },
      }],
    ],
    fields: [
      ['FieldReact', {
        name: 'skus',
        label: null,
        GlobalStyleComponent: createGlobalStyle`
          .generate-skus-modal {
            .ant-modal-body {
              padding: 20px;
            }
            .ant-modal-footer {
              padding: 20px 16px;
            }
            .ant-row {
              padding-bottom: 0px;
              margin-bottom: 0px;
            }
          }
        `,
        TableComponent: styled(AntdTable)`
          tbody > form {
            display: table-row !important;
            > td {
              display: table-cell !important;
            }
          }
        `,
        TableWrapperComponent: styled.div`
          td {
            padding: 0 !important;
          }
          .ant-table-fixed-left {
            z-index: 10 !important;
          }
          .ant-modal-footer {
            padding: 20px 16px;
          }
        `,
        TableHeaderWrapperComponent: styled.div`
          display: flex;
          flex-direction: column;
          * {
            white-space: nowrap;
          }
        `,
        TableHeaderTitleComponent: styled.div``,
        TableHeaderSubtitleComponent: styled.div`
          font-size: 70%;
          color: initial;
          opacity: 0.4;
        `,
        TableCellWrapperComponent: styled.div`
          display: flex;
          flex-direction: column;
          justify-content: center;
          /* align-items: center; */
          flex-shrink: 0;
          height: 45px;
          .ant-upload-list-item {
            margin-bottom: 5px;
            .ant-upload-list-item-card-actions {
              opacity: 1;
            }
            > div > span > .anticon {
              top: 4px;
            }
          }
          .ant-upload-list-item-info {
            margin-top: -3px;
          }
          ${({ $isMissing, theme }) => (
            $isMissing
              ? css`
                input {
                  color: ${theme.less.errorColor} !important;
                  opacity: 0.5 !important;
                  &::placeholder {
                    color: ${theme.less.errorColor} !important;
                  }
                }
              `
              : undefined
          )}
        `,
        TableCellMeasureComponent: styled.div`
          height: 0px;
          overflow: hidden;
          opacity: 0;
          width: auto;
          flex-shrink: 0;
          flex-grow: 0;
          padding: 0px 16px;
          white-space: pre;
        `,
        TableInputComponent: styled(TableInputHTML)`
          width: 100%;
          border-radius: 0;
          border: none;
          padding: 3px 16px;
          margin: 0px;
          width: 100%;
          height: 100%;
          ${({ $isNew, theme }) => (
            $isNew
              ? css`color: ${theme.less.textColor} !important;`
              : undefined
          )}
          background: ${({ $isFixed, $isDisabled }) => (
            $isFixed
              ? 'transparent !important'
              : $isDisabled
                ? '#fcfcfc !important'
                : 'transparent !important'
          )};
          &:focus {
            box-shadow: 0 0 0 1px inset ${({ theme }) => theme.less.primaryColor
          };
            z-index: 9;
          }
        `,
        getInitialValue: (config, props) => {
          const { parentForm: form } = props;
          const stock = props.data?.stock || {};
          const name = form.getFieldValue('name');
          const variants = form.getFieldValue('variants');
          const variationsCurrent = (
            form.getFieldValue('variations') || []
          ).filter(variation => !variation.isDefault);
          const variationDefaults = form.getFieldValue(
            'variationDefaults',
          );

          if (
            !name
            || !variants?.length
            || !variationDefaults
            || (variants || []).findIndex(
              variant => !variant?.choices?.length
            ) > -1
          ) {
            Admin.showMessage(
              'Make sure name, variants and details are filled and try again.',
              'error',
              5,
            );
            // props.modalAction.handleCancel();
            return {
              variationDefaults,
              variations: [],
              variationsMissing: [],
              variants: variants || [],
            };
          }

          const variantsMap = variants.reduce(
            (agr, variant) => {
              agr[variant._id] = variant.choices.reduce(
                (agrChoices, choice) => {
                  agrChoices.choicesMap[choice._id] = choice;
                  return agrChoices;
                },
                {
                  ...variant,
                  choicesMap: {},
                },
              );
              return agr;
            },
            {},
          );

          const {
            map: variationsCurrentVariantIdsMap,
            namesMap: variationsCurrentNamesMap,
            items: variationsCurrentItems,
          } = variationsCurrent.reduce(
            (agr, variation) => {
              const variantsId = variation.variantsId = (
                Object
                  .keys(variantsMap)
                  .sort()
                  .map(key => variation?.variants?.[key] || 'undefined')
                  .join('|')
              );
              const variationName = variation.name;
              const variationResult = { ...variation, variantsId };
              agr.map[variantsId] = variationResult;
              agr.namesMap[variationName] = variationResult;
              agr.items.push(variationResult);
              return agr;
            },
            { map: {}, namesMap: {}, items: [] },
          );

          const variationsCurrentItemsLeft = [
            ...variationsCurrentItems,
          ];

          const defaultKeys = Object.keys(variationDefaults);
          const defaultValues = defaultKeys.reduce(
            (agrValues, key) => {
              agrValues[key] = (
                typeof variationDefaults[key] === 'undefined'
                  ? ''
                  : `${variationDefaults[key]}`
              );
              return agrValues;
            },
            {},
          );

          const variations = variants.reduce(
            (agr, variant, index) => {
              const result = [];
              variant.choices.forEach(choice => {
                const agrVars = (
                  index === 0
                    ? [{
                      ...defaultKeys.reduce(
                        (agrValues, key) => {
                          agrValues[key] = '';
                          return agrValues;
                        },
                        {},
                      ),
                      defaultValues: { ...defaultValues },
                    }]
                    : agr
                );
                agrVars.forEach((variation) => {
                  const variationResult = {
                    ...variation,
                    _id: `${ObjectId()}`,
                    name: (
                      !index
                        ? `${choice.label}`
                        : `${variation.name} ${choice.label}`
                    ),
                    storeSku: (
                      !index
                        ? createSku(name, choice.label)
                        : createSku(variation.storeSku, choice.label)
                    ),
                    slug: (
                      !index
                        ? createSlug(choice.label)
                        : createSlug(variation.slug, choice.label)
                    ),
                    variants: {
                      ...(variation.variants || {}),
                      [variant._id]: choice._id,
                    },
                    variantLabels: {
                      ...(variation.variantLabels || {}),
                      [variant._id]: choice.label,
                    },
                  };
                  if (index === variants.length - 1) {
                    variationResult.defaultGenerated = {
                      name: variationResult.name,
                      storeSku: variationResult.storeSku,
                      slug: variationResult.slug,
                    };
                    const variantsId = variationResult.variantsId = (
                      Object
                        .keys(variantsMap)
                        .sort()
                        .map(key => (
                          variationResult?.variants?.[key]
                          || 'undefined'
                        ))
                        .join('|')
                    );
                    const variationCurrent = (
                      variationsCurrentVariantIdsMap[variantsId]
                      || variationsCurrentNamesMap[variationResult.name]
                    );
                    if (
                      variationCurrent
                      && variationsCurrentItemsLeft.includes(variationCurrent)
                    ) {
                      variationsCurrentItemsLeft.splice(
                        variationsCurrentItemsLeft.indexOf(
                          variationCurrent,
                        ),
                        1,
                      );
                    }
                    Object.assign(variationResult, {
                      ...(variationCurrent || {}),
                      variants: variationResult.variants,
                    });
                    variationResult.defaultStock = [
                      'LOCAL',
                      'WAREHOUSE',
                    ].reduce(
                      (stockAgr, storage) => {
                        stockAgr[storage] = (
                          stock[variationResult._id]?.[storage] || 0
                        );
                        return stockAgr;
                      },
                      {},
                    );
                    variationResult._isNew = !variationCurrent;
                    props.overridableKeys.forEach((key) => {
                      if (
                        variationCurrent?.overrides?.includes?.(key)
                        || (
                          `${variationResult.defaultValues?.[key]}`
                          === `${variationResult[key]}`
                        )
                      ) {
                        variationResult[key] = '';
                      }
                    });
                  }
                  result.push(variationResult);
                });
              });
              return result;
            },
            [],
          );

          const variationsMissing = [];

          variationsCurrentItemsLeft.forEach(({ variantsId }) => {
            const variation = (
              variationsCurrentVariantIdsMap[variantsId]
              || variationsCurrentNamesMap[
              variationsCurrentVariantIdsMap[variantsId]?.name
              ]
            );
            if (variation) {
              const variationResult = {
                ...variation,
                ...defaultKeys.reduce(
                  (agrValues, key) => {
                    agrValues[key] = '';
                    return agrValues;
                  },
                  {},
                ),
                _isMissing: true,
                defaultValues: { ...defaultValues },
                variantLabels: Object.keys(variation.variants || {}).reduce(
                  (agrVariantLabels, currentVariantId) => {
                    const variantChoice = (
                      variantsMap[currentVariantId]
                        ?.choicesMap
                      ?.[variation.variants[currentVariantId]]
                    );
                    agrVariantLabels[currentVariantId] = (
                      variantChoice?.label || '---'
                    );
                    return agrVariantLabels;
                  },
                  {},
                ),
              };
              variationResult.variantsId = (
                Object
                  .keys(variantsMap)
                  .sort()
                  .map(key => variationResult?.variants?.[key] || 'undefined')
                  .join('|')
              );
              variationResult.defaultStock = [
                'LOCAL',
                'WAREHOUSE',
              ].reduce(
                (stockAgr, storage) => {
                  stockAgr[storage] = (
                    stock[variationResult._id]?.[storage] || 0
                  );
                  return stockAgr;
                },
                {},
              );
              variationsMissing.push(variationResult);
              variations.push(variationResult);
            }
          });

          return {
            variationDefaults,
            variations,
            variationsMissing,
            variants,
          };
        },
        handleSetVariationValue: (props, index, column, value) => {
          props.onChange({
            ...props.value,
            variations: props.value.variations.map(
              (variation, variationIndex) => {
                if (index !== variationIndex) {
                  return variation;
                }
                let newVariation = JSON.parse(
                  JSON.stringify(variation)
                );
                if (column.handleChange) {
                  newVariation = column.handleChange(
                    value,
                    column,
                    newVariation,
                  ) || newVariation;
                } else {
                  setKey(
                    newVariation,
                    column.dataIndex,
                    value,
                  );
                }
                return newVariation;
              },
            ),
          });
        },
        fieldImage: Admin.compileFromLibrary(['FieldUploadRefs', {
          name: 'image',
          label: null,
          maxCount: 1,
          accept: 'image/jpg,image/jpeg,image/png,image/webp',
          listType: 'picture-small',
          uploadLabel: 'Upload Image',
          transformations: [
            ['GM', { command: 'compress', maxWidth: 2000 }],
            ['GM', { command: 'webp' }],
          ],
        }]),
        // eslint-disable-next-line arrow-body-style
        renderContent: (props) => {
          const {
            GlobalStyleComponent,
            TableComponent,
            TableWrapperComponent,
            TableHeaderWrapperComponent,
            TableHeaderTitleComponent,
            TableHeaderSubtitleComponent,
            TableCellWrapperComponent,
            TableCellMeasureComponent,
            TableInputComponent,
          } = props;

          const { currency } = Types.getSystemCountry(
            props.viewer.settings.systemCountry,
          );

          const columns = [
            ...props.value.variants.map(variant => ({
              title: variant.label,
              // subtitle: `Choices by ${variant.label}`,
              subtitle: 'Option',
              fixed: true,
              dataIndex: `variantLabels.${variant._id}`,
              InputComponent: TableInputComponent,
              disabled: true,
              // eslint-disable-next-line no-unused-vars
              getExtraInputProps: (text, record, index) => ({
                $isNew: !!record._isNew,
                value: getKey(
                  record,
                  `variantLabels.${variant._id}`,
                  '-',
                ),
              }),
            })),
            {
              title: 'Name',
              subtitle: 'Product name suffix',
              dataIndex: 'name',
              InputComponent: TableInputComponent,
            },
            {
              title: 'SKU',
              subtitle: 'Unique product SKU',
              dataIndex: 'storeSku',
              align: 'left',
              InputComponent: TableInputComponent,
            },
            {
              title: 'Link',
              subtitle: 'Product link suffix',
              dataIndex: 'slug',
              InputComponent: TableInputComponent,
            },
            ...(
              props.activity !== 'test'
                ? [
                  [
                    'LOCAL',
                    'Local Storage',
                    ShopOutlined,
                  ],
                  [
                    'WAREHOUSE',
                    'Packman Storage',
                    AppstoreOutlined,
                  ],
                ]
                : []
            ).map(([name, subtitle, IconComponent]) => ({
              title: (
                <>
                  Stock
                  &nbsp;
                  <IconComponent />
                </>
              ),
              subtitle,
              align: 'right',
              // minWidth: '120px',
              dataIndex: `stock.${name}`,
              defaultKey: `defaultStock.${name}`,
              InputComponent: TableInputComponent,
              placeholder: '0',
              disabled: (
                props.activity === 'create'
                && (
                  name === 'WAREHOUSE'
                  && props.viewer?.role === 'SELLER'
                )
              ),
            })),
            ...[
              [
                'price',
                'Price',
                '',
                'priceIncludingVat',
              ],
              [
                'priceIncludingVat',
                'Price + VAT',
                '',
                'price',
              ],
              [
                'priceBeforeSale',
                'Before Sale',
                '',
                'priceBeforeSaleIncludingVat',
              ],
              [
                'priceBeforeSaleIncludingVat',
                'Before Sale + VAT',
                '',
                'priceBeforeSale',
              ],
            ].map(([name, label, subtitle, calculatedName], i) => ({
              title: label,
              subtitle: `${subtitle} in ${currency}`,
              align: 'right',
              dataIndex: `${name}`,
              calculatedDataIndex: `${calculatedName}`,
              defaultKey: `defaultValues.${name}`,
              handleChange: (value, column, newVariation) => {
                const valueFloat = parseFloat(value, 10);
                if (Number.isFinite(valueFloat)) {
                  const calculatedValue = (
                    i % 2 === 0
                      ? getCalculatedPriceIncludingVat(
                        valueFloat,
                        { systemCountry: props.viewer.settings.systemCountry },
                      )
                      : getCalculatedPriceWithoutVat(
                        valueFloat,
                        { systemCountry: props.viewer.settings.systemCountry },
                      )
                  );
                  setKey(
                    newVariation,
                    column.calculatedDataIndex,
                    Number.isFinite(calculatedValue)
                      ? `${calculatedValue}`
                      : '',
                  );
                } else {
                  setKey(
                    newVariation,
                    column.calculatedDataIndex,
                    '',
                  );
                }
                setKey(
                  newVariation,
                  column.dataIndex,
                  value,
                );
                return newVariation;
              },
              InputComponent: TableInputComponent,
            })),
            ...[
              ['weight', 'grams'],
              ['length', 'cm'],
              ['width', 'cm'],
              ['height', 'cm'],
            ].map(([name, unit]) => ({
              title: `${name[0].toUpperCase()}${name.slice(1)}`,
              subtitle: `in ${unit}`,
              align: 'right',
              // minWidth: '120px',
              dataIndex: `${name}`,
              defaultKey: `defaultValues.${name}`,
              InputComponent: TableInputComponent,
            })),
            // {
            //   title: 'Image',
            //   dataIndex: 'image',
            //   // eslint-disable-next-line arrow-body-style
            //   render: (text, record, index) => {
            //     return (
            //       <TableCellWrapperComponent>
            //         {
            //           props.fieldImage.render({
            //             client: props.client,
            //             value: record.image || null,
            //             onChange: file => props.onChange({
            //               ...props.value,
            //               variations: props.value.variations.map(
            //                 (variation, variationIndex) => {
            //                   if (index !== variationIndex) {
            //                     return variation;
            //                   }
            //                   const newVariation = JSON.parse(
            //                     JSON.stringify(variation)
            //                   );
            //                   setKey(
            //                     newVariation,
            //                     'image',
            //                     file,
            //                   );
            //                   return newVariation;
            //                 },
            //               ),
            //             }),
            //           })
            //         }
            //         <TableCellMeasureComponent>
            //           {' '}
            //         </TableCellMeasureComponent>
            //       </TableCellWrapperComponent>
            //     );
            //   },
            // },
          ].map(({ InputComponent, title, subtitle, ...column }) => {
            if (InputComponent) {
              return {
                title: (
                  <TableHeaderWrapperComponent>
                    <TableHeaderTitleComponent>
                      {title || <>&nbsp;</>}
                    </TableHeaderTitleComponent>
                    <TableHeaderSubtitleComponent>
                      {subtitle || <>&nbsp;</>}
                    </TableHeaderSubtitleComponent>
                  </TableHeaderWrapperComponent>
                ),
                render: (text, record, index) => (
                  <TableCellWrapperComponent
                    $isMissing={!!record._isMissing}
                    title={record._isMissing ? 'Will be removed' : ''}
                  >
                    <InputComponent
                      name={column.dataIndex}
                      size="1"
                      style={{
                        textAlign: column.align || 'left',
                        minWidth: column.minWidth,
                      }}
                      value={getKey(record, column.dataIndex, '')}
                      placeholder={getKey(
                        record,
                        column.defaultKey,
                        column.placeholder || '',
                      )}
                      disabled={!!column.disabled || !!record._isMissing}
                      $isDisabled={!!column.disabled || !!record._isMissing}
                      $isFixed={!!column.fixed}
                      {...(
                        column.getExtraInputProps
                          ? column.getExtraInputProps(
                            text, record, index, props
                          )
                          : {}
                      )}
                      onKeyDown={(event) => {
                        const key = `${event.keyCode
                          || event.code
                          || event.which
                          }`;
                        if (key === '13') {
                          event.preventDefault();
                          event.stopPropagation();
                          const nextIndex = (
                            event.ctrlKey
                              ? index
                              : event.shiftKey
                                ? index - 1
                                : index + 1
                          );
                          if (nextIndex === index) {
                            props.handleSetVariationValue(
                              props,
                              nextIndex,
                              column,
                              record.defaultGenerated?.[
                              column.dataIndex
                              ],
                            );
                          } else {
                            const newFocusInput = (
                              document.querySelector([
                                '#generate-skus-table',
                                '.ant-table-tbody',
                                `tr:nth-child(${nextIndex + 1})`,
                                `input[name="${column.dataIndex}"]`,
                              ].join(' '))
                            );
                            if (newFocusInput) {
                              newFocusInput.select();
                              if (event.altKey) {
                                props.handleSetVariationValue(
                                  props,
                                  nextIndex,
                                  column,
                                  event.target.value,
                                );
                              }
                            }
                          }
                        }
                      }}
                      onChange={(event) => {
                        props.handleSetVariationValue(
                          props,
                          index,
                          column,
                          event.target.value,
                        );
                      }}
                    />
                    <TableCellMeasureComponent>
                      {
                        text
                        || getKey(
                          record,
                          column.defaultKey,
                          column.placeholder || '',
                        )
                      }
                    </TableCellMeasureComponent>
                  </TableCellWrapperComponent>
                ),
                ...column,
              }
            }
            return {
              // eslint-disable-next-line no-unused-vars
              render: (text, record, index) => (
                <TableCellWrapperComponent>
                  {text}
                </TableCellWrapperComponent>
              ),
              ...column,
            };
          });

          return (
            <>
              <GlobalStyleComponent />
              <TableWrapperComponent>
                <TableComponent
                  id="generate-skus-table"
                  size="small"
                  bordered
                  pagination={false}
                  dataSource={props.value.variations}
                  rowKey="_id"
                  scroll={{ x: 'max-content' }}
                  columns={columns}
                />
              </TableWrapperComponent>
            </>
          );
        },
      }],
    ],
  }], 12)),
]
